import { apiRequest } from './apiClient';

export const fetchCollections = async (options = {}) => {
  const params = new URLSearchParams();
  if (options.scopePicker) {
    params.set('scope_picker', 'true');
  }
  if (typeof options.search === 'string' && options.search.trim()) {
    params.set('search', options.search.trim());
  }
  if (Number.isInteger(options.page) && options.page >= 0) {
    params.set('page', String(options.page));
  }
  if (Number.isInteger(options.limit) && options.limit > 0) {
    params.set('limit', String(options.limit));
  }
  if (Array.isArray(options.selectedIds) && options.selectedIds.length > 0) {
    params.set('selected_ids', options.selectedIds.map((value) => String(value)).join(','));
  }

  const query = params.toString();
  return apiRequest(`/api/v1/collections${query ? `?${query}` : ''}`);
};

export const fetchProjectCollections = async (projectId) => {
  return apiRequest(`/api/v1/projects/${encodeURIComponent(projectId)}/collections`);
};

export const fetchTemplates = async () => {
  return apiRequest('/api/v1/templates?refresh_shared_status=false');
};

export const createCollection = async (title) => {
  return apiRequest('/api/v1/collections', {
    method: 'POST',
    body: JSON.stringify({ title }),
  });
};

export const renameCollection = async (collectionId, title) => {
  return apiRequest(`/api/v1/collections/${encodeURIComponent(collectionId)}`, {
    method: 'PATCH',
    body: JSON.stringify({ title }),
  });
};

export const deleteCollection = async (collectionId) => {
  return apiRequest(`/api/v1/collections/${encodeURIComponent(collectionId)}`, {
    method: 'DELETE',
  });
};

export const fetchAutoAddProjectConfig = async (collectionId) => {
  return apiRequest(
    `/api/v1/collections/${encodeURIComponent(collectionId)}/auto-add-project-config`
  );
};

export const saveAutoAddProjectConfig = async (collectionId, config) => {
  return apiRequest(
    `/api/v1/collections/${encodeURIComponent(collectionId)}/auto-add-project-config`,
    {
      method: 'PUT',
      body: JSON.stringify({
        templateId: config?.templateId,
        watchPath: config?.watchPath,
        enabled: config?.enabled,
      }),
    }
  );
};

export const addProjectToCollection = async (projectId, collectionId) => {
  return apiRequest(
    `/api/v1/projects/${encodeURIComponent(projectId)}/collections/${encodeURIComponent(collectionId)}`,
    { method: 'POST' }
  );
};

export const removeProjectFromCollection = async (projectId, collectionId) => {
  return apiRequest(
    `/api/v1/projects/${encodeURIComponent(projectId)}/collections/${encodeURIComponent(collectionId)}`,
    { method: 'DELETE' }
  );
};
